import { CardComp } from "../..";
import TablePagination from "../../Table/Pagination";

/**
 * Table card wrapper with consistent padding and pagination placement.
 */
export default function InvestorPortalTableSection({
  children,
  pagination,
  className = "",
  ...rest
}) {
  return (
    <CardComp cardClassName={`border-0 shadow-sm py-0 px-0 ${className}`} {...rest}>
      <div className="investor-portal-table-wrap">{children}</div>
      {pagination && pagination.total > 0 ? (
        <TablePagination {...pagination} marginBottom="1rem" />
      ) : null}
    </CardComp>
  );
}

export function useClientPagination(items, { page, perPage, setPage }) {
  const total = items?.length || 0;
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  const safePage = Math.min(page, totalPages);
  const pageData = items.slice((safePage - 1) * perPage, safePage * perPage);

  return {
    pageData,
    pagination: {
      currentPage: safePage,
      perPage,
      total,
      totalPages,
      count: pageData.length,
      handlePageChange: setPage,
    },
  };
}

/** Link-style cell for navigable table rows */
export function TableRowLink({ children, onClick }) {
  return (
    <button
      type="button"
      className="btn btn-link p-0 text-start fw-semibold text-decoration-none border-0"
      style={{ color: "var(--color-secondary)", fontSize: 14 }}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
